import getDefaultHeaders from '@americanexpress/iguazu-resources/utils/getDefaultHeaders';
import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    content,
    locale,
    taxonomy,
    directory,
  }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/${directory ? `${directory}` : 'common'}/${locale?.toLowerCase()}/${taxonomy ? `${taxonomy}/` : ''}${content}.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
      },
      ...getDefaultHeaders(),
    },
  }),
};
